import mixpanel from 'mixpanel-browser';
import EVENT_NAME from 'utils/const';

const Mixpanel = {
  initialize: () => {
    mixpanel.init(process.env?.REACT_APP_MIX_PANEL, {
      debug: false // enable debug log in console
    });
  },

  trackPageView: (page) => {
    mixpanel.track(EVENT_NAME.PAGE_VIEW, { page });
  },

  trackEvent: (eventName, params) => {
    mixpanel.track(eventName, params);
  },

  identifyUser: (userId) => {
    mixpanel.identify(userId);
  }
};

export default Mixpanel;
